import { Configuration2D } from '../../../models/configurators-2d/configuration2d';
import { BaseAppService } from '../../../services/configurators-2d/base-app-service';

export abstract class BaseItem<C extends Configuration2D, S extends BaseAppService<C>> {
  constructor(private appService: S) {}

  get configuration(): C {
    return this.service.configuration;
  }

  get service(): S {
    return this.appService;
  }
}
